import { create } from "zustand";

// Published by the resume generator; consumed by the ReconnectingIndicator banner.
// `connecting` is the expected first connection attempt after a thread switch/resume.
// `retrying` is only used after a failed attempt; `attempt` is the upcoming attempt
// number (so attempt=2 means "first attempt failed, about to retry").
export type ReconnectStatus = "idle" | "connecting" | "retrying" | "exhausted";

type ReconnectState = {
  status: ReconnectStatus;
  threadId: string | null;
  attempt: number;
  setConnecting: (threadId: string) => void;
  setRetrying: (threadId: string, attempt: number) => void;
  setExhausted: (threadId: string) => void;
  setIdle: (threadId?: string) => void;
};

export const useReconnectStateStore = create<ReconnectState>((set) => ({
  status: "idle",
  threadId: null,
  attempt: 0,
  setConnecting: (threadId) => set({ status: "connecting", threadId, attempt: 1 }),
  setRetrying: (threadId, attempt) => set({ status: "retrying", threadId, attempt }),
  setExhausted: (threadId) => set({ status: "exhausted", threadId, attempt: 0 }),
  setIdle: (threadId) =>
    set((state) => {
      if (threadId != null && state.threadId != null && state.threadId !== threadId) {
        return state;
      }
      return { status: "idle", threadId: null, attempt: 0 };
    }),
}));
